var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fa',{staticClass:"fa-fw eb-fast-spin",attrs:{"icon":['far', 'spinner-third'],"spin":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }